export default __webpack_public_path__ + "static/media/Dither Background Image.93805882.jpg";